import { CarShiftPatternIcon } from './CarShiftPatternIcon';

/**
 * author: Colton Wiscombe
 * id DF11B72C-D029-49BB-9657-6A267CC1DEA4
 * name car-shift-pattern
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/car-shift-pattern.svg
 * tags
 * - Automotive 
 */
export const CarTransmissionIcon = CarShiftPatternIcon;
export default CarTransmissionIcon